import React, { useState } from "react";
import { Button } from "@stonelog/stonelog-design-system";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";
import { useSelector, useDispatch } from "react-redux";
import {
  routesManagementSelector,
  setAreaSelectionMode,
} from "../../../../../../../../../features/senninha/routesManagementSlice";

import * as S from "./styles";

// Controle de seleção de pins por área (retângulo/laço) no mapa.
// Botão inicial "Desenhar área de seleção" → expande em Retângulo / Laço / Fechar.
// O modo ativo mora no Redux (`areaSelectionMode`), lido pelo AreaSelector no mapa.
// Reutilizado por RelocateRoutes, PreDeliveryRoutes e AutonomosRoutes.
const AreaSelectControl = () => {
  const dispatch = useDispatch();
  const { areaSelectionMode } = useSelector(routesManagementSelector);
  const [expanded, setExpanded] = useState(false);

  const toggleAreaMode = (mode) =>
    dispatch(setAreaSelectionMode(areaSelectionMode === mode ? null : mode));

  const closeAreaSelect = () => {
    setExpanded(false);
    dispatch(setAreaSelectionMode(null));
  };

  return (
    <S.AreaSelectContainer>
      {!expanded ? (
        <Button size="small" solid onClick={() => setExpanded(true)}>
          <GingaIcon name="notes" color="#303742" size="16px" />
          Desenhar área de seleção
        </Button>
      ) : (
        <>
          <p>Selecione vários pins de uma vez desenhando uma área no mapa.</p>
          <S.AreaSelectButtons>
            <Button
              type={areaSelectionMode === "rectangle" ? "primary" : "neutral"}
              solid={areaSelectionMode !== "rectangle"}
              size="small"
              onClick={() => toggleAreaMode("rectangle")}
            >
              <GingaIcon
                size="16px"
                name="menu-app"
                color={areaSelectionMode === "rectangle" ? "#FFF" : "#303742"}
              />
              Retângulo
            </Button>
            <Button
              type={areaSelectionMode === "lasso" ? "primary" : "neutral"}
              solid={areaSelectionMode !== "lasso"}
              size="small"
              onClick={() => toggleAreaMode("lasso")}
            >
              <GingaIcon
                size="16px"
                name="edit"
                color={areaSelectionMode === "lasso" ? "#FFF" : "#303742"}
              />
              Laço
            </Button>
            <Button
              type="neutral"
              solid
              size="small"
              width="36px"
              height="36px"
              onClick={closeAreaSelect}
            >
              <GingaIcon size="16px" name="close" color="#303742" />
            </Button>
          </S.AreaSelectButtons>
        </>
      )}
    </S.AreaSelectContainer>
  );
};

export default AreaSelectControl;
